import { CONNECT } from "../types";

export const connect = () => {
    return {
        type: CONNECT,
    };
};